// RFC 4180-style CSV escaping. Quotes any field that contains a comma, quote,
// newline, or carriage return; doubles internal quotes.
export const escapeCsvField = (value) => {
  if (value === null || value === undefined) return ''
  const str = String(value)
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export const toCsv = (headers, rows) => {
  const headerLine = headers.map(escapeCsvField).join(',')
  const bodyLines = rows.map(row => row.map(escapeCsvField).join(','))
  return [headerLine, ...bodyLines].join('\r\n')
}

export const downloadCsv = (filename, csvContent) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}
